import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-antOutline-arrow-left Copy",
  "use": "icon-antOutline-arrow-left Copy-usage",
  "viewBox": "64 64 896 896",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"64 64 896 896\" id=\"icon-antOutline-arrow-left Copy\">\r\n    <path d=\"M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 0 0 0 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z\" />\r\n  </symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/antOutline-arrow-left Copy.svg
// module id = cgnA
// module chunks = 24